<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        class="screenInput"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        ><el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.order_num"
        placeholder="请输入订单编号"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入姓名"
      ></el-input>
      <el-input
        class="screenInput numInput"
        v-model="screen.phone"
        type="number"
        placeholder="请输入手机号"
        maxlength="11"
      ></el-input>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.order_status"
        placeholder="请选择付款状态"
      >
        <el-option label="全部付款状态" value=""></el-option>
        <el-option label="待付款" value="1"></el-option>
        <el-option label="付款成功" value="2"></el-option>
        <el-option label="付款失败" value="3"></el-option>
        <el-option label="取消支付" value="4"></el-option>
        <el-option label="已退款" value="5"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.status"
        placeholder="请选择核销码状态"
      >
        <el-option label="全部核销码状态" value=""></el-option>
        <el-option label="未核销" value="1"></el-option>
        <el-option label="已核销" value="2"></el-option>
        <el-option label="已过期" value="3"></el-option>
      </el-select>
      <el-date-picker
        class="screenInput"
        v-model="screen.date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择预约日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="唯一编号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.order_num }}</div>
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约日期" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status == 1">待付款</el-tag>
          <el-tag v-else-if="scope.row.order_status == 2" type="success"
            >付款成功</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 3" type="danger"
            >付款失败</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 4" type="warning"
            >取消支付</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 5" type="info"
            >已退款</el-tag
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="核销码状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1">未核销</el-tag>
          <el-tag v-else-if="scope.row.status == 2" type="success"
            >已核销</el-tag
          >
          <el-tag v-else-if="scope.row.status == 3" type="danger"
            >已过期</el-tag
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
       <el-table-column prop="created_at" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="refund(scope.row.id)"
            v-if="roles.includes('/garden/fishing_order_refund') && scope.row.order_status == 2"
            >退款</el-button
          >
          <!--<el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/garden/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/garden/edit')"
            >编辑</el-button
          >
          
          
          <div style="margin-top: 10px;" v-if="scope.row.status == 2">
            <el-button
            size="mini"
            type="warning"
            @click="relDelete(scope.row.id)"
            v-if="roles.includes('/garden/del_rel')"
            >删除认领关系</el-button
          >
          </div>
          -->
        </template> 
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>
<script>
import { openPark } from "@/api/index";
import { mapGetters } from "vuex";
import { fishingOrderLists ,fishingOrderRefund} from "@/api/smartFarm";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      listLoading: false,
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        name: "",
        phone: "",
        date: "",
        order_num: "",
        order_status: "",
        status: "",
      },
      parkList: [],
      list: [],
      total: 0,
    };
  },
  created() {
    this.fetchData();
    this.getPark();
  },
  methods: {
  // 退款
  refund(id) {
      var that = this;
      this.$confirm("确认退款？")
        .then(() => {
          fishingOrderRefund({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message:res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 分页 end
    // 重置
    reset() {
      this.screen = {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        name: "",
        phone: "",
        date: "",
        order_num: "",
        order_status: "",
        status: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取数据
    fetchData() {
      this.listLoading = true;
      fishingOrderLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
